import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { numberToDollars } from '../utils'

const Symbol = styled.span`
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
`

const Digits = styled.span`
  color: ${p => p.theme.darkestGray ?? '#022a3a'};
`

/** Renders a number as a formatted dollar amount. */
const Money = ({ value, className }) =>
  Number.isFinite(value) ? (
    <span className={className}>
      {value < 0 && <Digits>-</Digits>}
      <Symbol>$</Symbol>
      <Digits>{numberToDollars(Math.abs(value))}</Digits>
    </span>
  ) : null

Money.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
}

export default Money
